import React from 'react';
import './TheBiz.css';

function TheBiz() {
  const policies = [
    {
      title: 'Shipping Policy',
      description: 'Our shipping methods, delivery times, and international shipping information.',
      icon: '🚚',
      link: '/shipping-policy',
      color: '#3498db'
    },
    {
      title: 'Terms of Service',
      description: 'Terms and conditions for using our website and purchasing our products.',
      icon: '📜',
      link: '/terms',
      color: '#9b59b6'
    },
    {
      title: 'Returns Policy',
      description: 'Information about returns, exchanges, and refunds.',
      icon: '🔄',
      link: '/returns',
      color: '#e74c3c'
    },
    {
      title: 'Privacy Policy',
      description: 'How we collect, use, and protect your personal information.',
      icon: '🔒',
      link: '/privacy',
      color: '#2ecc71'
    }
  ];

  const faqs = [
    {
      question: 'How long does shipping usually take?',
      answer: 'Domestic orders typically arrive within 5–7 business days. International shipping times vary by location, usually between 10–20 business days. You\'ll receive tracking information as soon as your order ships.'
    },
    {
      question: 'What is your return window?',
      answer: 'We offer a 30-day return policy from the date of delivery. Items must be in original condition with tags attached. Some items may be final sale (clearly marked at purchase).'
    },
    {
      question: 'How do I contact customer service?',
      answer: 'You can reach our customer service team at support@thebiz.com or through our contact form. We typically respond within 24 hours during business days.'
    },
    {
      question: 'Do you ship internationally?',
      answer: 'Yes! We ship to over 50 countries worldwide. Shipping costs and delivery times vary by destination. All international orders may be subject to customs fees.'
    },
    {
      question: 'How secure is my personal information?',
      answer: 'We use industry-standard SSL encryption to protect your data. We never store full credit card numbers and only collect necessary information for order processing.'
    },
    {
      question: 'Can I modify or cancel my order?',
      answer: 'Orders can be modified or cancelled within 1 hour of placement. After that, they enter processing and cannot be changed. Contact us immediately if you need assistance.'
    }
  ];

  const values = [
    {
      title: 'Transparency',
      description: 'No hidden fees, no fine print. We believe in clear communication about our practices.'
    },
    {
      title: 'Customer First',
      description: 'Your satisfaction guides every decision we make, from product selection to support.'
    },
    {
      title: 'Quality Assurance',
      description: 'Every product meets our high standards before it reaches you.'
    },
    {
      title: 'Sustainable Practices',
      description: 'We\'re committed to ethical sourcing and environmentally conscious operations.'
    }
  ];

  return (
    <div className="thebiz-page">
      {/* Hero Section */}
      <section className="biz-hero">
        <div className="container">
          <div className="hero-content">
            <h1>The Biz</h1>
            <p className="subtitle">
              Your guide to how we operate – our policies, terms, and how we handle your information.
              Transparency is at the heart of what we do.
            </p>
          </div>
        </div>
      </section>

      {/* Policies Grid */}
      <section className="policies-section">
        <div className="container">
          <h2 className="section-title">Our Policies</h2>
          <p className="section-subtitle">Everything you need to know about how we do business</p>
          <div className="policies-grid">
            {policies.map((policy, index) => (
              <a href={policy.link} className="policy-card" key={index}>
                <div className="policy-icon" style={{ backgroundColor: policy.color }}>
                  <span className="icon-emoji">{policy.icon}</span>
                </div>
                <h3>{policy.title}</h3>
                <p>{policy.description}</p>
                <div className="policy-link">
                  Learn more <span className="arrow">→</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <p className="section-subtitle">The principles that guide our business</p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div className="value-card" key={index}>
                <div className="value-number">0{index + 1}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Quick answers to common questions</p>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Still have questions?</h2>
            <p>Can't find what you're looking for? Our team is here to help.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn-primary">Contact Us</a>
              <a href="mailto:support@thebiz.com" className="btn-secondary">Email Support</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TheBiz;